import { SelectionModel } from '@angular/cdk/collections';
import { Component } from '@angular/core';

import { SearchNavbarBaseSubformComponent } from '@shared/components/search-layout/search-navbar/search-navbar-base-subform/search-navbar-base-subform.component';
import { CustomerSegmentTypes } from '@shared/interfaces/customer-segments.type';
import { RetailerSegmentTypes } from '@shared/interfaces/retailer-segments.type';

@Component({
  selector: 'app-customer-segment-subform',
  templateUrl: './customer-segment-subform.component.html',
  styleUrls: ['./customer-segment-subform.component.scss'],
})
export class CustomerSegmentSubformComponent extends SearchNavbarBaseSubformComponent {
  customerSelection = new SelectionModel<string>(true, []);

  retailerSelection = new SelectionModel<string>(true, []);

  customerSegmentTypes = CustomerSegmentTypes;

  retailerSegmentTypes = RetailerSegmentTypes;

  isAllRetailerSegmentSelected(): boolean {
    if (
      this.retailerSelection.selected.length ===
      this.retailerSegmentTypes.length
    ) {
      return this.retailerSelection.selected.every((element) => {
        if (this.retailerSegmentTypes.includes(element)) {
          return true;
        }

        return false;
      });
    }

    return false;
  }

  override updateValue(filter?: any): void {
    this.clear();
    if (filter) {
      if (filter.customerSegments?.length > 0) {
        filter.customerSegments.forEach((customerSegment: any) => {
          if (customerSegment === 'RETAILER') {
            filter.retailerSegments.forEach((retailerSegment: any) => {
              this.retailerValueChanged(retailerSegment);
            });
          } else {
            this.customerValueChanged(customerSegment);
          }
        });
      }
    } else {
      this.clear();
    }
  }

  customerValueChanged(control?: string): void {
    if (control) {
      if (control === 'RETAILER') {
        if (this.isAllRetailerSegmentSelected()) {
          this.retailerSelection.clear();
          this.customerSelection.deselect(control);
        } else {
          this.retailerSelection.select(...this.retailerSegmentTypes);
          this.customerSelection.select(control);
        }
      } else {
        this.customerSelection.toggle(control);
      }

      this.updateCostumerStore(true);
      this.updateRetailerStore(true);
    } else {
      this.updateCostumerStore(false);
    }
  }

  retailerValueChanged(control?: string): void {
    if (control) {
      this.retailerSelection.toggle(control);

      if (this.retailerSelection.hasValue()) {
        this.customerSelection.select('RETAILER');
      } else {
        this.customerSelection.deselect('RETAILER');
      }

      this.updateCostumerStore(true);
      this.updateRetailerStore(true);
    } else {
      this.updateRetailerStore(false);
    }
  }

  updateCostumerStore(withSelected: boolean): void {
    this.store.dispatch(
      this.filterUpdater.trigger({
        filter: {
          customerSegments: withSelected
            ? this.customerSelection.selected
            : undefined,
        },
      })
    );
  }

  updateRetailerStore(withSelected: boolean): void {
    this.store.dispatch(
      this.filterUpdater.trigger({
        filter: {
          retailerSegments: withSelected
            ? this.retailerSelection.selected
            : undefined,
        },
      })
    );
  }

  override clear(): void {
    this.customerSelection.clear();
    this.retailerSelection.clear();
    this.customerValueChanged();
    this.retailerValueChanged();
  }
}
